function buscarComunas() {
  // Obtener el valor del input y convertirlo a mayúsculas
  var input = document.getElementById('searchInput');
  var filtro = input.value.toUpperCase();

  // Obtener la tabla y las filas
  var tabla = document.getElementById('tablaComunas');
  var filas = tabla.getElementsByTagName('tr');

  // Recorrer todas las filas de la tabla
  for (var i = 2; i < filas.length; i++) {
    // Empezamos desde 2 para saltar los encabezados
    var celda = filas[i].getElementsByTagName('td')[0]; // Primera celda de cada fila (comuna)
    if (celda) {
      var textoCelda = celda.textContent || celda.innerText;
      if (textoCelda.toUpperCase().indexOf(filtro) > -1) {
        filas[i].style.display = ''; // Mostrar la fila si coincide
      } else {
        filas[i].style.display = 'none'; // Ocultar la fila si no coincide
      }
    }
  }
}